import { useEffect } from 'react';

export const useIfDefined = (action, query, key?) => {
  const memoised = Array.isArray(query) ? query : [query];
  const itExists = (params) => {
    if (Array.isArray(query)) return params.reduce((result, current) => result && current, true);
    return key ? params[key] : params;
  };
  useEffect(() => {
    let unmount = () => {};
    if (itExists(query)) {
      unmount = action();
    }
    return unmount;
    // eslint-disable-next-line no-autofix/react-hooks/exhaustive-deps
  }, memoised);
};
